export var getReconnectAttempts = function () {
    return process.env.NODE_ENV === 'development' ? 1 : undefined;
};
//# sourceMappingURL=getReconnectAttempts.js.map